module.exports = __webpack_public_path__ + "img/photo-12.8439d901.jpg";